import { render } from "./Playground.vue?vue&type=template&id=9224b0b6"
import script from "./Playground.vue?vue&type=script&lang=js"
export * from "./Playground.vue?vue&type=script&lang=js"
script.render = render

export default script